/**
 * Format a date to a string in the format DD/MM/YYYY
 */
export function formatDateForDisplay(date: Date): string {
  if (!date || isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
